export default function Work() {
  return (
    <div id="experience" className="Work">
      <div className="wrapper">
      <h3>
        Work Experience
      </h3>
      <div className="workCard">
        <h5>Software Engineer</h5>
        <h6>MyJourney Health</h6>
        <ul>
          <li>Developed full-stack applications from the ground up, using Angular, TypeScript, Node.js, and MongoDB, delivering a secure and scalable solution tailored to client needs.</li>
          <li>Led the development of multiple new features in a large-scale Angular application, collaborating closely with product managers and UX designers.</li>
          <li>Continuously optimized and refactored existing features for performance and maintainability, reducing technical debt across the codebase and leading to a reduced page load time by 40% by optimizing Angular change detection strategy.</li>
          <li>Designed and implemented scalable backend APIs using Node.js and MongoDB.</li>
          <li>Integrated Whisper API to create features for clinical data extraction and cut patient creation time by 50% by building a dynamic form generation system with ChatGPT API.</li>
        </ul>
      </div>

      <i class="fa-solid fa-grip-lines-vertical"></i>
      <div className="workCard">
        <h5>Software Developer</h5>
        <h6>From Lab 2 Fulfillment</h6>
        <ul>
          <li>Developed multiple full-stack applications using React, JavaScript, SCSS, Node.js, and Express, meeting strict project timelines and client requirements. </li>
          <li>Utilized Agile methodologies to collaborate seamlessly with cross-functional teams, ensuring efficient development cycles and delivering high-quality results. </li>
          <li>Reviewed and debugged code in multiple languages, enhancing codebase reliability and functionality.</li>
          <li>Spearheaded migration of legacy services to modern containerized deployments using Docker and Google Cloud, streamlining DevOps processes.</li>
        </ul>
      </div>

      <i class="fa-solid fa-grip-lines-vertical"></i>
      <div className="workCard">
        <h5>Web Developer</h5>
        <h6>Freelance</h6>
        <ul>
          <li>Delivered end-to-end solutions for clients including UI/UX design, front-end development, backend API integration, and deployment.</li>
          <li>Consulted with clients to gather requirements and proposed scalable tech stacks suited to each project's needs.</li>
        </ul>
      </div>

      <i class="fa-solid fa-grip-lines-vertical"></i>
      <div className="workCard">
        <h5>Maintenance Supervisor</h5>
        <h6>Grand Niagara</h6>
        <ul>
          <li>Directed and supervised a team of employees, overseeing the successful completion of diverse projects.</li>
          <li>Worked closely with management to implement efficiency enhancements, resulting in up to a 25% increase in productivity within specific areas.</li>
        </ul>
      </div>

      <i class="fa-solid fa-grip-lines-vertical"></i>
      <div className="workCard">
        <h5>Technical Support Advisor</h5>
        <h6>Concentrix</h6>
        <ul>
          <li>Managed diverse customer requests and promptly addressed emerging issues. </li>
          <li>Demonstrated adaptability and a commitment to continuous learning to enhance call efficiency. </li>
        </ul>
      </div>

      </div>
    </div>
  )
}